export default __webpack_public_path__ + "static/media/whatsapp.cf27d2fb.gif";